import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import EventBus from "../utils/EventBus";
import demoService from "../services/demo.service";

export const createdemo = createAsyncThunk(
  "api/createdemo",
  async (stateData, thunkAPI) => {
    try {
      const data = await demoService.createNewDemo(stateData);
      return { demodata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getdemo = createAsyncThunk(
  "api/getdemo",
  async (thunkAPI) => {
    try {
      const data = await demoService.getDemo();
      return { demodata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getdemobyid = createAsyncThunk(
  "api/getdemobyid",
  async (id, thunkAPI) => {
    try {
      const data = await demoService.getDemoById(id);
      return { demodata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updatedemo = createAsyncThunk(
  "api/updatedemo",
  async ({e_id, formData}, thunkAPI) => {
    try {
      const data = await demoService.updateDemo(e_id, formData);
      return { demodata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deletedemo = createAsyncThunk(
  "api/deletedemo",
  async ({e_id}, thunkAPI) => {
    try {
      const data = await demoService.deleteDemo(e_id);
      return { demodata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState ={
    demos: [],
    demoDetail: null
}

const demoSlice = createSlice({
  name: "api",
  initialState,
  extraReducers: {
    [createdemo.fulfilled]: (state, action) => {
      state.demos.push(action.payload.demodata.data)
      return state;
    },
    [createdemo.rejected]: (state, action) => {
      state.demos = action.payload.demodata
      return state;
    },
    [getdemo.fulfilled]: (state, action) => {
    state.demos = action.payload.demodata.data
    return state;
  },
  [getdemo.rejected]: (state, action) => {
    state.demos = action.payload.demodata
    return state;
  },
  [getdemobyid.fulfilled]: (state, action) => {
    state.demoDetail = action.payload.demodata.data[0]
    return state;
  },
  [updatedemo.fulfilled]: (state, action) => {
    const {
      arg: { e_id },
    } = action.meta;
    if (e_id) {
      state.demos = state.demos.map((item) =>
        item.id === e_id ? action.payload.demodata.data : item
      );
    };
    state.message = action.payload.demodata.message
  },
  [updatedemo.rejected]: (state, action) => {
    state.message = action.payload.demodata.message
  },
  [deletedemo.fulfilled]: (state, action) => {
    const {
      arg: { e_id },
    } = action.meta;
    if (e_id) {
      state.demos = state.demos.filter((item) => item.id !== e_id);
    };
    state.message = action.payload.demodata.message
  },
  },
});

const { reducer } = demoSlice;
export default reducer;